import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"max-height":"300px","overflow-y":"auto"} }
const _hoisted_2 = {
  key: 0,
  class: "text-center text-grey pa-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialog) = $event)),
    "max-width": "500px"
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps({
        color: "primary",
        variant: "outlined"
      }, props, {
        class: "filter-btn mt-4",
        style: {"background-color":"#ffffff"}
      }), {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("mdi-filter", -1)
            ]))]),
            _: 1
          }),
          (_ctx.selectedClassIds.length > 0)
            ? (_openBlock(), _createBlock(_component_v_chip, {
                key: 0,
                class: "ml-2",
                size: "x-small",
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.selectedClassIds.length), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 16)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createElementVNode("span", { class: "text-h6" }, "クラス絞り込み", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_select, {
                modelValue: _ctx.selectedYear,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedYear) = $event)),
                items: _ctx.yearOptions,
                label: "年度",
                variant: "outlined",
                density: "compact",
                class: "mb-2",
                "item-title": "text",
                "item-value": "value",
                color: "primary",
                "hide-details": "auto"
              }, null, 8, ["modelValue", "items"]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_list, { density: "compact" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredClasses, (nurseryClass) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: nurseryClass.classId,
                        value: nurseryClass.classId,
                        color: "primary",
                        onClick: ($event: any) => (_ctx.toggleSelection(nurseryClass.classId)),
                        active: _ctx.selectedIndexes.includes(nurseryClass.classId)
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_list_item_action, { start: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox_btn, {
                                "model-value": _ctx.selectedIndexes.includes(nurseryClass.classId),
                                color: "primary"
                              }, null, 8, ["model-value"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(nurseryClass.className), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value", "onClick", "active"]))
                    }), 128))
                  ]),
                  _: 1
                }),
                (_ctx.filteredClasses.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, " この年度にクラスがありません "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "text",
                color: "grey",
                onClick: _ctx.clearFilter
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("クリア", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                color: "grey",
                onClick: _ctx.closeDialog
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("キャンセル", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                variant: "text",
                color: "primary",
                onClick: _ctx.applyFilter
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("保存", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}